const UNLOCK_KEY = "adminUnlocked";
const PASSWORD_KEY = "adminPassword";

export function isAdminUnlocked(): boolean {
  return sessionStorage.getItem(UNLOCK_KEY) === "1";
}

export function setAdminUnlocked(password: string): void {
  sessionStorage.setItem(UNLOCK_KEY, "1");
  sessionStorage.setItem(PASSWORD_KEY, password);
}

export function clearAdminSession(): void {
  sessionStorage.removeItem(UNLOCK_KEY);
  sessionStorage.removeItem(PASSWORD_KEY);
}

export function getAdminPassword(): string {
  return sessionStorage.getItem(PASSWORD_KEY) ?? "";
}

export function getConfiguredAdminPassword(): string {
  const raw = import.meta.env.VITE_ADMIN_PASSWORD;
  return typeof raw === "string" ? raw.trim() : "";
}

export function isAdminRouteEnabled(): boolean {
  return getConfiguredAdminPassword().length > 0;
}
